export const PLAY_SONG = 'PLAY_SONG';
export const PAUSE_SONG = 'PAUSE_SONG';
export const SAVE_SONG_DATA = 'SAVE_SONG_DATA';
export const FETCH_SONG_FAIL = 'FETCH_SONG_FAIL';
export const SAVE_AUDIO = 'SAVE_AUDIO'


// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js